import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import { TextField, InputAdornment } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { Listings } from 'containers/AppContainer/typings';
import { getCalculatedAmount } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { getCivilJudgement } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/utils';
import { INCIDENT_TYPE } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/constants';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';

export interface CivilJudgementRecapVictimProps {
  intl: IntlShape;
  listings?: Listings;
  isManager?: boolean;
  dahirAmount?: any;
  responsabilityShareValue?: string;
  expertises?: any;
  isAppeal?: boolean;
  isRejected?: boolean;
  judgementOnMeritsRequest: any;
  civj: any;
  civjvm?: any;
  motifListExpertise: any;
  isContested?: boolean;
  handleOpenContestation: Function;
  handleExpertiseChange: Function;
  civilJudgementType: any;
  handleCivJvmChange: Function;
  judgementOnMerits: any;
  sagisVictimInfo: any;
  judgement: any;
  setJudgement: Function;
  expertiseType?: any;
  civilJudgementUpdateExpertise?: any;
  setCivilJudgementUpdateExpertise?: Function;
  setJudgementOnMeritsRequest?: Function;
  victim?: any;
  expertiseJudgementAddDocumentId?: number;
  withAccountingExpertise?: any;
  mode?: string;
}
const Picker = {
  ACCOUNTING: ({ ...props }) => {
    return (
      <>
        {((props.isJudgementOnMeritsContested && props.isManager) ||
          (!props.isManager && !props.isRejected)) && (
          <TextField
            label={translate(messages.revenueFieldTitle, props)}
            value={get(props.civj, 'evaluationAmount', '')}
            inputProps={{
              readOnly: true,
            }}
            className="calculated-amount"
          />
        )}
        {((!props.isContested && props.isManager) ||
          (props.isRejected && !props.isManager)) && (
          <TextField
            id="acc_text_field"
            label={translate(messages.revenueFieldTitle, props)}
            value={
              /* istanbul ignore next */
              props.expertises && get(props.currentCivj, 'evaluationAmount', '')
            }
            onChange={
              props.handleExpertiseChange &&
              props.handleExpertiseChange(
                get(
                  props.civj,
                  'id',
                  `${props.victim?.id}-${props.expertiseJudgementAddDocumentId}`,
                ),
                0,
                INCIDENT_TYPE.VICTIM,
                get(props, 'victim', props.civjvm?.victim),
              )
            }
            name="evaluationAmount"
            type="number"
            className="calculated-amount"
          />
        )}

        <div className="text-field-amount">
          {((!props.isContested && props.isManager) ||
            (!props.isManager && props.isRejected)) && (
            <TextField
              id="acc_calculated_amount"
              className="calculated-amount"
              label={translate(messages.calculatedRevenue, props)}
              value={
                /* istanbul ignore next */
                props.expertises &&
                get(props.currentCivj, 'calculatedRevenue', '')
              }
              name="calculatedRevenue"
              onChange={
                props.handleExpertiseChange &&
                props.handleExpertiseChange(
                  get(
                    props.civj,
                    'id',
                    `${props.victim?.id}-${props.expertiseJudgementAddDocumentId}`,
                  ),
                  2,
                  INCIDENT_TYPE.VICTIM,
                  get(props, 'victim', props.civjvm?.victim),
                )
              }
            />
          )}
          {((props.isContested && props.isManager) ||
            (!props.isManager && !props.isRejected)) && (
            <TextField
              className="calculated-amount"
              label={translate(messages.calculatedRevenue, props)}
              value={props.civj?.calculatedRevenue}
              inputProps={{
                readOnly: true,
              }}
            />
          )}
        </div>
      </>
    );
  },
  MEDICAL: ({ ...props }) => (
    <>
      {((props.isContested && props.isManager) ||
        (!props.isManager && !props.isRejected)) && (
        <TextField
          className="calculated-amount"
          label={translate(messages.compensationFieldTitle, props)}
          value={props.civj?.compensationAmount}
          inputProps={{
            readOnly: true,
          }}
        />
      )}
      {((!props.isContested && props.isManager) ||
        (props.isRejected && !props.isManager)) && (
        <TextField
          className="calculated-amount"
          id="med_text_field"
          label={translate(messages.compensationFieldTitle, props)}
          value={
            /* istanbul ignore next */
            props.expertises && get(props.currentCivj, 'compensationAmount', '')
          }
          name="compensationAmount"
          onChange={
            props.handleExpertiseChange
              ? props.handleExpertiseChange(
                  get(
                    props.civj,
                    'id',
                    `${props.victim?.id}-${props.expertiseJudgementAddDocumentId}`,
                  ),
                  0,
                  INCIDENT_TYPE.VICTIM,
                  get(props, 'victim', props.civjvm?.victim),
                )
              : () => {}
          }
        />
      )}
      {featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        get(props.withAccountingExpertise, 'hasAccountingExpertise') && (
          <>
            {((props.isJudgementOnMeritsContested && props.isManager) ||
              (!props.isManager && !props.isRejected)) && (
              <TextField
                label={translate(messages.revenueFieldTitle, props)}
                value={get(props.currentCivj, 'evaluationAmount', '')}
                inputProps={{
                  readOnly: true,
                }}
                className="calculated-amount"
              />
            )}
            {((!props.isContested && props.isManager) ||
              (props.isRejected && !props.isManager)) && (
              <TextField
                id="acc_text_field"
                label={translate(messages.revenueFieldTitle, props)}
                value={
                  /* istanbul ignore next */
                  props.expertises &&
                  get(props.currentCivj, 'evaluationAmount', '')
                }
                onChange={
                  props.handleExpertiseChange &&
                  props.handleExpertiseChange(
                    get(
                      props.civj,
                      'id',
                      `${props.victim?.id}-${props.expertiseJudgementAddDocumentId}`,
                    ),
                    2,
                    INCIDENT_TYPE.VICTIM,
                    get(props, 'victim', props.civjvm?.victim),
                  )
                }
                name="evaluationAmount"
                type="number"
                className="calculated-amount"
              />
            )}
          </>
        )}
    </>
  ),
} as any;
const CivilJudgementRecapVictim: React.FC<CivilJudgementRecapVictimProps> = ({
  ...props
}): JSX.Element => {
  const Component = Picker[props.civilJudgementType];
  const currentCivj = getCivilJudgement(
    props.expertises || [],
    props.civj,
    props.victim,
    INCIDENT_TYPE.VICTIM,
  );
  return (
    <div style={{ paddingTop: '10px' }}>
      {props.civilJudgementType && (
        <Component {...props} currentCivj={currentCivj} />
      )}
      <div className="text-field-amount">
        <TextField
          className="calculated-amount"
          label={translate(messages.calculatedCompensationFieldTitle, props)}
          value={getCalculatedAmount(
            props.dahirAmount,
            props.judgementOnMeritsRequest,
            props.civj,
            props.victim,
          )}
        />
      </div>
      {!props.isAppeal && (
        <div className="text-field-amount">
          {((props.isContested && props.isManager) ||
            (!props.isManager && !props.isRejected)) && (
            <TextField
              className="calculated-amount"
              label={translate(messages.provisionalExecutionFieldTitle, props)}
              value={props.civj.provisionalExecution}
              inputProps={{
                readOnly: true,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {translate(
                      { ...messages.responsibiltySharePercentage },
                      props,
                    )}
                  </InputAdornment>
                ),
              }}
            />
          )}
          {!props.isAppeal &&
            ((!props.isContested && props.isManager) ||
              (props.isRejected && !props.isManager)) && (
              <TextField
                id="med_calculated_amount"
                className="calculated-amount"
                label={translate(
                  messages.provisionalExecutionFieldTitle,
                  props,
                )}
                value={
                  /* istanbul ignore next */
                  props.expertises &&
                  get(currentCivj, 'provisionalExecution', '')
                }
                name="provisionalExecution"
                onChange={
                  props.handleExpertiseChange
                    ? props.handleExpertiseChange(
                        get(
                          props.civj,
                          'id',
                          `${props.victim?.id}-${props.expertiseJudgementAddDocumentId}`,
                        ),
                        1,
                        INCIDENT_TYPE.VICTIM,
                        get(props, 'victim', props.civjvm?.victim),
                      )
                    : () => {}
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {translate(
                        { ...messages.responsibiltySharePercentage },
                        props,
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            )}
        </div>
      )}
    </div>
  );
};

export default injectIntl(CivilJudgementRecapVictim);
